import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Typography } from "@material-ui/core";
import Link from "./../../components/plain-link";
import ProfilePicture from "./../../components/profile-picture";
import Notifications from "./components/notifications";
import ProfileSettings from "./components/profile-settings";
import useStyles from "./styles";

export default function Settings() {
  const classes = useStyles();
  const profilePicture = useSelector(
    (state) => state.userPreferences.profilePicture
  );
  const displayName = useSelector((state) => state.userPreferences.displayName);
  const { notifications } = useParams();

  return (
    <div className={classes.root}>
      <div className={classes.sidebar}>
        <ProfilePicture
          picturePath={profilePicture}
          className={classes.profilePicture}
        />
        <Typography variant="h1" className={classes.displayName}>
          Welcome, {displayName}
        </Typography>
        <div className={classes.nav}>
          <Typography className={classes.navTitle}>Account Settings</Typography>
          <ul className={classes.list}>
            <li className={classes.listItem}>
              <Link to="/settings">Profile Settings</Link>
            </li>
            <li className={classes.listItem}>
              <Link to="/settings/notifications">Notifications</Link>
            </li>
          </ul>
        </div>
      </div>
      <div className={classes.main}>
        {notifications ? <Notifications /> : <ProfileSettings />}
      </div>
    </div>
  );
}
